module.exports = __webpack_public_path__ + "media/images/emblems/Belfaux-coat_of_arms-a15e26d44c19a9e0131a0198ea20d3e0.svg";